import {
    actionSamples
} from "./actions";
import {
    basicPrimitiveSamples
} from "./basicPrimitives";
import {
    basicSurfaceSamples
} from "./basicSurfaces";
import {
    chatSamples
} from "./chat";
import {
    dataSamples
} from "./data";
import {
    formSamples
} from "./form";
import {
    layerSamples
} from "./layers";
import {
    mobileSamples
} from "./mobile";
import {
    navigationSamples
} from "./navigation";
import type {
    AnatomySampleMap
} from "../types";

export const ANATOMY_SAMPLES: AnatomySampleMap = {
    ...basicPrimitiveSamples,
    ...basicSurfaceSamples,
    ...navigationSamples,
    ...actionSamples,
    ...mobileSamples,
    ...layerSamples,
    ...chatSamples,
    ...formSamples,
    ...dataSamples
};
